// extracted by mini-css-extract-plugin
export default {"container":"AttentionText_container__fnIUW","strong":"AttentionText_strong__yOP2i","icon":"AttentionText_icon__GcRuj"};